import * as React from 'react'
import { withStatus } from '../status'
import { withFields } from '../fields'
import { withNavigation } from '../navigation'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import routeBlockerActions from './route-blocker-actions'
import configLS from "../../../landlords/config";
import configContents from "../../../contents/config";
import {withConfig} from "../config";


/*

Use this component on all routes that may potentially be blocked. This typically entails
all steps/pages of a form aside from restore.

This component works in tandem with the state of the navigation module. If the current route is present in the
state.navigation.disabledRoutes blacklist, the form is automatically reset.

*/

function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        routeLogic: state.routeLogic
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            routeBlocker: bindActionCreators(routeBlockerActions, dispatch)
        }
    }
}


export function withRouteBlocker(Wrapped){


    return withNavigation(withFields(withStatus(withConfig(connect( mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{

        constructor(props){
            super(props)
            this.state = {
                unloadHandler: this.handleUnload.bind(this)
            }
        }
        
    
        componentWillMount(){
            // Check if the route is disabled. If it is redirected to step 1 and refresh the browser
            const isProjLs = this.props.config.project === 'landlords';
            const isLsInMaintenance = configLS.showMaintenance;
            if (isProjLs && isLsInMaintenance && this.props.location.pathname != '/maintenance') {
                console.log("INVALID PATH!!!!")
                this.props.actions.navigation.resetFormInMaintenance();
                return;
            }

            // Redirect to the maintenance page if the project is contents and maintenance mode is on
            const isProjContents = this.props.config.project === 'contents';
            const isContentsInMaintenance = configContents.showMaintenance;
            if (isProjContents && isContentsInMaintenance && this.props.location.pathname != '/maintenance') {
                console.log("INVALID PATH!!!!")
                this.props.actions.navigation.resetFormInMaintenance();
                return;
            }

            if( this.props.navigation.disabledRoutes.indexOf(this.props.location.pathname) != -1){
                console.log("Route disabled! Reload")
                this.props.actions.navigation.resetForm();
                return;
            }

            // Check for existing token. If it is not step-1 or restore then return to step 1
            if( this.props.fields.token == null){
                    if(this.props.location.pathname != "/step-1"
                        && this.props.location.pathname != "/restore"
                        && this.props.location.pathname != "/payment-result"
                        && this.props.location.pathname != "/maintenance"){
                        console.log("INVALID PATH!!!!")
                        this.props.actions.navigation.resetForm();
                        return;
                    }
            }
           
            // Ensure that a warning message appears when the user attempts to exit the page
            this.props.actions.navigation.setCloseWarning(true);
            
            // Add a listener to check when the user attempts to close the window/tab
            window.addEventListener("beforeunload", this.state.unloadHandler)
        }


        componentWillUnmount(){
            window.removeEventListener("beforeunload", this.state.unloadHandler)
        }


        handleUnload(e){
            console.log("Warn on close: " + this.props.navigation.warnOnClose);
            if(this.props.navigation.warnOnClose){
                console.log("Show warning")
                var confirmationMessage = "Changes that you made may not be saved.";
                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            }else{
                console.log("Dont show warning")
                return true;
            }
        }
        

        render(){
            return (
                <div>
                    <Wrapped { ...this.props } />
                </div>
            )
        }
    
    })))))
    

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/route-blocker/index.tsx